const checkout = {
  steps: {
    cart: 'Cart',
    customerData: 'Customer Data',
    delivery: 'Delivery Method',
    payment: 'Payment',
    overview: 'Review',
  },
  cart: {
    product: 'Product',
    emptyCart: 'Your cart is empty',
    emptyCartDescription1: 'There are no products in your cart yet. Discover',
    emptyCartDescription2: 'our pharmacy range or',
    redeemPrescription: 'redeem your (E-)prescription',
    removeProduct: 'Are you sure you want to remove this product from your cart?',
    myLife: {
      title: 'Free for You',
      description: 'Please include the latest my life magazine with my order.',
    },
    prescriptionsTitle: 'Your (E-)Prescriptions (XX)',
    prescriptionsSubtitle: 'Please present your original prescription when receiving the product. This will complete the purchase agreement.',
    productsTitle: 'Products (XX)',
    noPaymentOptions: 'No Online Payment',
    carouselTitle: 'Currently Popular',
    goToProductOverview: 'Go to Product Overview',
    removePrescriptions: 'Remove prescriptions',
    removeProducts: 'Remove products',
    removeAllModal: {
      prescriptionsTitle: 'Clear (E-)Prescriptions',
      prescriptionsDescription: 'Are you sure you want to remove all (E-)prescriptions from your cart? The cart cannot be restored.',
      productsTitle: 'Clear Items',
      productsDescription: 'Are you sure you want to remove all products from your cart? The cart cannot be restored.',
      cancel: 'Cancel',
      confirm: 'Yes, I’m sure',
    },

  },
  pricing: {
    subtotal: 'Subtotal',
    delivery: 'Courier Service',
    coupon: 'Coupon',
    total: 'Total Amount',
    vat: 'incl. VAT',
    freeOfCharge: 'free of charge',
    totalOfflineDelivery: 'Total Amount for Payment on Delivery',
    coPaymentPharmacyInfo: 'Co-payment information for prescriptions will be provided at the pharmacy',
    totalOnlinePayment: 'Total Amount for Online Payment',
    totalTooltip: {
      title: 'Price Calculation Information',
      section1: {
        title: 'Your cart contains (E-)prescriptions',
        content: {
          1: `For pre-orders containing a prescription, the co-payment amount, as well as the amount to be paid by privately insured patients for medication,
          <strong>can only be determined and communicated after the pre-order is completed by the pharmacist.</strong>`,
          2: 'Therefore, the amount displayed here is <strong>a preliminary price information.</strong>',
          3: 'The costs for prescription products <strong>will be added.</strong>',
        },
      },
      section2: {
        title: 'Your cart contains (E-)prescriptions',
        content: 'The <strong>co-payment per product</strong> for statutory health insurance is',
        list: {
          item1: 'Co-payment exempt: 0 €',
          item2: 'Co-payment required: Between 5 and 10 €',
        },
      },
    },
    removeCoupon: 'Remove Coupon',
  },
  cartOverview: {
    overview: 'Overview',
    couponCode: 'Enter Coupon Code',
    redeem: 'Redeem',
    toCheckout: 'Proceed to Checkout',
  },
  customer: {
    successfulRegistration: `You have successfully registered.
    Please verify your account after completing your order by clicking the link we sent to your email.`,
  },
  delivery: {
    deliveryWithCourierService: 'Delivery with Courier Service',
    deliveryByAgreementTitle: 'Delivery by Agreement',
    deliveryByAgreementDescription: 'Your pharmacy will contact you after the order is placed.',
    deliveryByAgreementAdditionalCostsMessage: 'Additional costs for courier delivery may apply and are not included in the total amount.',
    expressDeliveryTitle: 'Express Courier Delivery',
    expressDeliveryCosts: 'Express Costs',
    expressDeliveryPeriodInfo: 'Within [time] minutes<sup>6</sup> after order confirmation',
    homeDeliveryTitle: 'Scheduled Courier Service',
    homeDeliveryCosts: 'Courier Costs',
    nextPeriod: 'Next Available Slot',
    pickupTitle: 'Pickup at Pharmacy',
    pickupDescription: 'The pharmacy will notify you by SMS when your order is ready for pickup.',
    freeOfCharge: 'free of charge',
    newAddressPromise: '{strongText} We use your phone number only for potential inquiries from the pharmacy regarding your pre-orders. Additionally, you will be informed via SMS and email about the status of your order.',
    newAddressPromiseTitle: 'Our Promise:',
    newAddressForm: {
      chooseDeliveryAddress: 'Please choose your delivery address',
      addNew: 'Add New Address',
      company: 'Company',
      additionalInfo: 'Additional Information',
      street: 'Street',
      houseNumber: 'House Number',
      save: 'Save',
    },
    chooseDeliveryOption: 'Choose Delivery Option',
    chooseDeliveryTime: 'Please choose your preferred delivery time',
    unsavedAddressMessage: 'Please save your address details so that delivery options can be checked.',
    unsavedAddressChangesMessage: 'You must save your changes to continue.',
    zipCodesModal: {
      listOfExpressDeliveryZipCodes: 'List of ZIP Codes Available for Express Delivery',
      listOfExpressDeliveryZipCodesDescription: 'The following ZIP codes are eligible for express courier service from this pharmacy',
      listOfHomeDeliveryZipCodes: 'List of ZIP Codes Available for Home Delivery',
      listOfHomeDeliveryZipCodesDescription: 'The following ZIP codes are eligible for regular courier service from this pharmacy',
    },
  },
  payment: {
    paymentAtPharmacy: 'Payment at Pharmacy',
    paymentAtPharmacyDescription: 'You can pay in cash or with another accepted payment method at your pharmacy.',
    paymentAtCourier: 'Payment at Courier',
    paymentAtCourierDescription: 'You can pay in cash or with another accepted payment method by the courier.',
    continueAsPreOrder: 'Continue as Pre-Order',
    paymentOnline: 'Pay Online Now',
    enterPaymentAddress: 'Please enter your billing address',
    selectPaymentMethod: 'Please select your preferred payment method',
    sameAsDeliveryAddress: 'Same as Delivery Address',
    unsavedAddressChangesMessage: 'You must save your changes to continue.',
    differentPaymentAddress: 'Different Billing Address',
    newAddressAdded: 'New address successfully added.',
    productsWithoutOnlinePaymentMessage: 'Products without online payment must be paid upon delivery',
  },
  overview: {
    overviewDescription: 'Please review your information again.',
    expressDeliveryDescription: 'Your order will be delivered within {time} minutes after the pharmacy confirms the order.',
    pickupAlertText: 'Save double trips: Your pharmacy will notify you when your order is ready for pickup.',
    paymentMethod: 'Payment Method',
    whatsApp: {
      title: 'WhatsApp Consultation',
      agreement: 'Agree to WhatsApp Communication',
      hint: 'You may withdraw your consent at any time.',
    },
    deliveryAddress: 'Delivery Address',
    paymentAddress: 'Billing Address',
    dearMan: 'Dear',
    dearWoman: 'Dear',
    hello: 'Hello',
    onlinePayment: 'Online Payment',
    paymentWithCourier: 'Payment with Courier',
    prescriptionMessage: 'Your pharmacy will inform you about the co-payment amount.',
    form: {
      consent: 'I agree that my order details may be shared with the selected pharmacy. I can revoke my consent until the pre-order is processed.',
      newsletter: 'Sign up for our free newsletter to receive regular product recommendations and news about your pharmacy.',
    },
    payPalRedirect: 'You will be redirected to',
    freeMyLifeInsert: 'Free insert of the my life magazine',
    preOrder: 'Pre-Order',
    feePreOrder: 'Pre-Order with Fees',
  },
  thankYou: {
    message: {
      title: 'Thank you for your order at {pharmacyName}',
      orderNumber: 'Order Number',
      preOrderNumber: 'Pre-Order Number',
      toOverview: 'To Order Overview',
      toStartPage: 'To Start Page',
      continueShopping: 'Continue Shopping',
    },
    orderError: {
      title: 'Your order could not be completed',
      subtitle: 'Please try again.',
    },
    whatsApp: {
      title: 'Order Confirmation via WhatsApp',
      description: 'You will receive a confirmation of your order via WhatsApp.',
      buttonText: 'WhatsApp',
    },
    bullets: {
      emailWithDetails: 'You will receive an email with your order details shortly.',
      orderStatus: 'Your pharmacy will keep you updated on the status of your order via email and SMS.',
      pickUp: 'You can pick up your order at the pharmacy.',
      deliveryTime: 'Your order will be delivered on {deliveryTime}.',
      deliveryByAgreement: 'Your pharmacy will contact you to arrange a delivery time.',
      expressDeliveryTime: 'Your order will be delivered within {minutes} minutes after the pharmacy confirms the order.',
      alert: 'Please present your original prescription when receiving your order.',
    },
    appBlock: {
      title: 'Install Our App',
      bullet1: 'With additional services for our customers with regular pharmacy product and service needs:',
      bullet2: 'Wishlist with reminders for <strong>regular orders and medication intake</strong>',
      bullet3: 'Overview of all non-prescription orders for <strong>tax return or insurance reimbursement</strong>',
    },
    bannerBlock: {
      nowInPharmacy: 'Now in Our Pharmacy',
      vaccineTitle: 'First? Second? Booster? We vaccinate!',
      vaccineDescription: '<strong>Reserve an appointment</strong> at your local pharmacy',
      vaccineLink: 'Book vaccination appointment',
      makeAppointment: 'Book appointment online now',
      immunityTitle: 'Covid-19 Immunity Proof',
      immunityDescription: '<strong>Digital or on a chip card</strong> now at your local pharmacy',
      immunityLink: 'Learn more',
    },
    registerBlock: {
      registerNow: 'Register now and order even faster in the future',
      setPassword: 'Just set a password and you are ready to go!',
      password: 'Password *',
      notice: 'Notice: ',
      passwordRules: 'Password must contain at least 1 uppercase letter, 1 lowercase letter, and 1 number',
      register: 'Register now',
    },
  },
}

export default checkout
